import { BpType } from '../enums';

export const BpTypes = [
  BpType.PENDING,
  BpType.OPTIMAL,
  BpType.NORMAL,
  BpType.ELEVATED,
  BpType.STAGE_1,
  BpType.STAGE_2,
  BpType.STAGE_3,
];
